import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

function Arrow({ direction, icon, onClick, size = 'medium' }) {
  const arrowSizeClasses =
    size === 'medium' ? 'h-10 w-10 md:w-16' : 'h-8 w-8 md:w-10';
  const arrowDirectionClasses = direction === 'right' ? 'right-4' : 'left-4';

  return (
    <button
      type="button"
      className={`bg-none border-none rounded-md cursor-pointer outline-none p-2 absolute top-1/2 transform -translate-y-1/2 ${arrowSizeClasses} ${arrowDirectionClasses} select-none`}
      onClick={onClick}
      onTouchEnd={onClick}
    >
      <Icon fill={'#fff'} type={icon} />
    </button>
  );
}

Arrow.propTypes = {
  theme: PropTypes.object,
  direction: PropTypes.oneOf(['left', 'right']),
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['medium', 'small']).isRequired,
};

export default Arrow;
